module.exports = __webpack_public_path__ + "img/steeve.ee530d48.jpg";